<template>
  <div ref="wrapper" class="load-more">
    <slot />
  </div>
</template>

<script>
import { throttle } from 'throttle-debounce'

export default {
  props: {
    scrollId: {
      type: String,
      default: '',
    },
    /**
     * 距离底部距离阈值emit
     */
    bottomThreshold: {
      type: Number,
      default: 200,
    },
    /**
     * 锁住则不emit
     */
    lock: {
      type: Boolean,
      default: false,
    },
    /**
     * 不能加载不emit
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      $root: null,
    }
  },

  destroyed() {
    const root = this.scrollId ? document.getElementById(this.scrollId) : window
    root.removeEventListener('scroll', this.scrollHandler.bind(this))
  },

  mounted() {
    if (!this.disabled) {
      const root = this.scrollId ? document.getElementById(this.scrollId) : window
      root.addEventListener('scroll', this.scrollHandler.bind(this))
    }
  },

  methods: {
    scrollHandler: throttle(200, function handler() {
      const root = this.scrollId ? document.getElementById(this.scrollId) : document.body
      let { scrollHeight, scrollTop } = root
      const screenHeight = window.screen.height
      scrollTop = scrollTop ? scrollTop : document.documentElement.scrollTop
      const isReachBottom =
        scrollHeight - scrollTop - screenHeight < this.bottomThreshold
      if (isReachBottom && !this.lock && !this.disabled) {
        this.$emit('load')
      }
    }),
  },
}
</script>
